/* src/app/pages/audit/analysis-trail/table/table.component.scss */
table {
  width: 100%;
}
.col-md-4 {
  margin-left: auto;
  margin-bottom: 10px;
}
/*# sourceMappingURL=table.component.css.map */
